import {Migration} from '@mydocma/core/src/lib/migration';
import {V1 as pV1} from './mm-project-db/v1';
import {V2 as pV2} from './mm-project-db/v2';
import {V3 as pV3} from './mm-project-db/v3';
import {V4 as pV4} from './mm-project-db/v4';
import {V5 as pV5} from './mm-project-db/v5';
import {V6 as pV6} from './mm-project-db/v6';
import {V7 as pV7} from './mm-project-db/v7';
import {V8 as pV8} from './mm-project-db/v8';
import {V9 as pV9} from './mm-project-db/v9';
import {V10 as pV10} from './mm-project-db/v10';
import {V11 as pV11} from './mm-project-db/v11';
import {V12 as pV12} from './mm-project-db/v12';
import {V13 as pV13} from './mm-project-db/v13';
import {V14 as pV14} from './mm-project-db/v14';
import {V15 as pV15} from './mm-project-db/v15';
import {V16 as pV16} from './mm-project-db/v16';
import {V17 as pV17} from './mm-project-db/v17';
import {V18 as pV18} from './mm-project-db/v18';
import {V19 as pV19} from './mm-project-db/v19';
import {V20 as pV20} from './mm-project-db/v20';

import {V1} from './mm-db/v1';

export const projectDbMigration = new Map<number, Migration>([
  [1, pV1],
  [2, pV2],
  [3, pV3],
  [4, pV4],
  [5, pV5],
  [6, pV6],
  [7, pV7],
  [8, pV8],
  [9, pV9],
  [10, pV10],
  [11, pV11],
  [12, pV12],
  [13, pV13],
  [14, pV14],
  [15, pV15],
  [16, pV16],
  [17, pV17],
  [18, pV18],
  [19, pV19],
  [20, pV20],
]);

export const dbMigration = new Map<number, Migration>([
  [1, V1]
]);

